import React from "react";
import Card from "~components/atoms/card/card";
import { BLOK_ARRAY } from "../../../prop_types";
import RichText from "../rich_text/rich_text";

function RichTextAlertCard({ richText: richTextArray, settings }) {
  const [richText] = richTextArray || [];
  return (
    <Card settings={settings}>{richText && <RichText {...richText} />}</Card>
  );
}

RichTextAlertCard.propTypes = {
  richText: BLOK_ARRAY,
  settings: BLOK_ARRAY,
};

RichTextAlertCard.defaultProps = {
  richText: null,
  settings: null,
};

export default RichTextAlertCard;
